/**
 * Module dependencies,
 */

import { CheckUpForm } from 'src/components/forms/check-up';
import { GetStaticProps, NextPage } from 'next';
import { SEO } from 'src/components/core/seo';
import { SSGProps } from 'src/types/app';
import { TriggerNavbarTheme } from 'src/components/layout/navbar/trigger-navbar-theme';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouterHistory } from 'src/providers/route-history';
import { useTranslation } from 'next-i18next';

/**
 * `CheckUp` page.
 */

const CheckUp: NextPage = () => {
  const { t } = useTranslation('check-up');
  const { previousRoute } = useRouterHistory();

  return (
    <>
      <SEO title={t('title')} />

      <TriggerNavbarTheme theme={'light'} />

      <CheckUpForm modalCloseButtonLink={previousRoute} />
    </>
  );
};

/**
 * Export `getStaticProps`.
 */

export const getStaticProps: GetStaticProps<SSGProps> = async ({ locale }) => {
  return {
    props: {
      hideFooter: true,
      hideNavigation: true,
      navbarTheme: 'light',
      ...(await serverSideTranslations(locale as string, [
        'common',
        'check-up'
      ]))
    },
    revalidate: 60
  };
};

/**
 * Export `CheckUp` component.
 */

export default CheckUp;
